<template>
  <div :class="['page_table', pageTableClass]">
    <h4
      v-if="tableTitle"
      class="page_table_head_text"
    >
      {{ tableTitle }}
    </h4>
    <div class="page_table_scroll">
      <table class="receive_terms_table">
        <thead>
          <tr class="page_table_bg_primary">
            <th
              v-for="(header, idx) in tableData.header"
              :key="idx"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(cols, idx) in tableData.data"
            :key="idx"
          >
            <template
              v-for="num in tableData.header.length"
              :key="num"
            >
              <td
                v-if="cols[`col${num}`]"
                :rowspan="cols[`col${num}`]['rowspan'] || 1"
              >
                <span
                  v-if="isObjKeyExist(cols[`col${num}`], 'clickHandle')"
                  :class="isObjKeyExist(cols[`col${num}`], 'textClass') ? cols[`col${num}`].textClass : ''"
                  @click="cols[`col${num}`].clickHandle()"
                >
                  {{ cols[`col${num}`]['text'] }}
                </span>

                <span
                  v-else
                  :class="isObjKeyExist(cols[`col${num}`], 'textClass') ? cols[`col${num}`].textClass : ''"
                >
                  {{ cols[`col${num}`]['text'] }}
                </span>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { isObjKeyExist } from '@/libs/global';

export default {
  name: 'TermsDataTable',
  props: {
    pageTableClass: {
      type: String,
      default () {
        return '';
      }
    },
    tableTitle: {
      type: String,
      default () {
        return '';
      }
    },
    tableData: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup () {
    return { isObjKeyExist };
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/common/common.scss';
@import '@/scss/termsDataTable.scss';
</style>
